export default "__VITE_ASSET__CQdf1SjH__"